import { Button } from '@sunwebgroup/uds-ui/button'
import * as Collapsible from '@sunwebgroup/uds-ui/collapsible'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
// TODO: migrate to @sunwebgroup/uds-ui when available
import { useBreakpoints } from '@sunwebgroup/ui-components/uds'
import cn from 'classnames'
import { isEmpty } from 'ramda'
import { useState } from 'react'
import { useIntl } from '@/intl'
import { getTransportSelector, routesSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './FlightTypeInfo.module.css'

export function FlightTypeInfo() {
  const { inboundRoutes, outboundRoutes } = usePricesSelector(routesSelector)
  const { loading: isFetching } = usePricesSelector(getTransportSelector)
  const intl = useIntl()
  const [open, setOpen] = useState(false)

  if (isFetching || isEmpty(outboundRoutes) || isEmpty(inboundRoutes))
    return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <Typography variant="body-m-bold-snug">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_title' })}
        </Typography>
        <Typography variant="body-m-regular-snug">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_title_text' })}
        </Typography>
        <Collapsible.Root open={open} onOpenChange={setOpen}>
          <div className={styles.infoGrid}>
            <TitleRow />
            <Row1 />
            <Row2 />
            <Row3 />
          </div>
          <Collapsible.Content>
            <div className={styles.infoGrid}>
              <Row4 />
              <Row5 />
              <Row6 />
              <Row7 />
              <Row8 />
            </div>
          </Collapsible.Content>
          <Collapsible.Trigger asChild>
            <Button className={styles.triggerButton} variant="transparentPrimary" size="S">
              {intl.formatMessage({
                id: 'prices_transport_selector_flight_type_info_toggle_text',
              })}
              <Button.Icon glyph={open ? 'ChevronUp' : 'ChevronDown'} size={16} />
            </Button>
          </Collapsible.Trigger>
        </Collapsible.Root>
        <Typography
          variant="body-m-regular-snug"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_extra_text' }),
          }}
        />
      </div>
    </div>
  )
}

function TitleRow() {
  const intl = useIntl()
  const { isTabletOrGreater } = useBreakpoints()

  return (
    <>
      <div className={styles.infoGridItem} />
      <div className={styles.infoGridItem}>
        {isTabletOrGreater && <Icon className={styles.icon} glyph="AirplaneToTop" size={16} /> }
        <Typography variant="body-s-bold-snug">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_standard_title' })}
        </Typography>
      </div>
      <div className={styles.infoGridItem}>
        {isTabletOrGreater && <Icon className={styles.icon} glyph="AirplaneWithArrowsCirclePath" /> }
        <Typography variant="body-s-bold-snug">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_flexible_title' })}
        </Typography>
      </div>
    </>
  )
}

function Row1() {
  const intl = useIntl()
  const { isTabletOrGreater } = useBreakpoints()

  return (
    <>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        {isTabletOrGreater && <Icon className={styles.icon} glyph="BackpackWithCheckMark" /> }
        <Typography variant="body-xs-bold-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_handbag' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_included' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_included' })}
        </Typography>
      </div>
    </>
  )
}
function Row2() {
  const intl = useIntl()
  const { isTabletOrGreater } = useBreakpoints()

  return (
    <>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        {isTabletOrGreater && <Icon className={styles.icon} glyph="LuggageCheck" /> }
        <Typography variant="body-xs-bold-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_checked_baggage' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography
          variant="body-xs-regular-flat"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_booked_additionally_non_flexible' }),
          }}
        />
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_booked_additionally' })}
        </Typography>
      </div>
    </>
  )
}
function Row3() {
  const intl = useIntl()
  const { isTabletOrGreater } = useBreakpoints()

  return (
    <>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        {isTabletOrGreater && <Icon className={styles.icon} glyph="AirplaneToRight" /> }
        <Typography variant="body-xs-bold-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_change_flight' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_for_fee' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_change_flight_before_departure' })}
        </Typography>
      </div>
    </>
  )
}
function Row4() {
  const intl = useIntl()
  const { isTabletOrGreater } = useBreakpoints()

  return (
    <>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        {isTabletOrGreater && <Icon className={styles.icon} glyph="BeachUmbrella" /> }
        <Typography variant="body-xs-bold-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_change_booking' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_for_fee' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography
          variant="body-xs-regular-flat"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_free_cancellation' }),
          }}
        />
      </div>
    </>
  )
}
function Row5() {
  const intl = useIntl()
  const { isTabletOrGreater } = useBreakpoints()

  return (
    <>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        {isTabletOrGreater && <Icon className={styles.icon} glyph="Checklist" /> }
        <Typography variant="body-xs-bold-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_change_name' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_for_fee' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_free_one_week' })}
        </Typography>
      </div>
    </>
  )
}
function Row6() {
  const intl = useIntl()
  const { isTabletOrGreater } = useBreakpoints()

  return (
    <>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        {isTabletOrGreater && <Icon className={styles.icon} glyph="Group" /> }
        <Typography variant="body-xs-bold-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_group_booking' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_max_persons' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_suitable' })}
        </Typography>
      </div>
    </>
  )
}
function Row7() {
  const intl = useIntl()
  const { isTabletOrGreater } = useBreakpoints()

  return (
    <>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        {isTabletOrGreater && <Icon className={styles.icon} glyph="Wallet" /> }
        <Typography variant="body-xs-bold-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_deposit' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_flight_cost_included' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_pay_for_flight_principal' })}
        </Typography>
      </div>
    </>
  )
}
function Row8() {
  const intl = useIntl()
  const { isTabletOrGreater } = useBreakpoints()

  return (
    <>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        {isTabletOrGreater && <Icon className={styles.icon} glyph="Wallet" /> }
        <Typography
          variant="body-xs-regular-flat"
          dangerouslySetInnerHTML={{
            __html: intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_exchange-guarantee' }),
          }}
        />
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_flight_rebooking' })}
        </Typography>
      </div>
      <div className={cn(styles.infoGridItem, styles.infoGridRowItem)}>
        <Typography variant="body-xs-regular-flat">
          {intl.formatMessage({ id: 'prices_transport_selector_flight_type_info_six-week-departure' })}
        </Typography>
      </div>
    </>
  )
}
